import { render, staticRenderFns } from "./Serve.vue?vue&type=template&id=661087b4"
import script from "./Serve.vue?vue&type=script&lang=js"
export * from "./Serve.vue?vue&type=script&lang=js"
import style0 from "./Serve.vue?vue&type=style&index=0&id=661087b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports